<template>
  <div>
    <b-row class="mb-4">
      <b-col md="11" >
        &nbsp;
        </b-col>
      <b-col md="1" >
              <span class="icon-small">
               <i 
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i>
                </span>
            </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          style="font-size: 8.5pt;"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        ></b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";

export default {
  data: () => {
    return {
      fields: [
        {
          key: "Parent.Territory.TerritoryName",
          label: "Territory",
          sortable: true,
          thStyle: "width: 15%;",
        },
        {
          key: "DateOfSeating",
          label: "Date",
          sortable: true,
          formatter: "mmdd",
        },
        {
          key: "Restaurant.Name",
          label: "Restaurant",
          sortable: true,
          thStyle: "width: 15%;",
        },
        {
          key: "SeminarType.SeminarTypeName",
          label: "Type",
          sortable: true,
        },
        {
          key: "RSVPCount",
          label: "RSVPs",
          sortable: true,
        },
        {
          key: "ConfirmedAttendees",
          label: "ATTs",
          sortable: true,
        },
        {
          key: "RestaurantID" + "_1",
          label: "%",
          sortable: true,
          formatter: "attendeePerc",
        },
        {
          key: "ConfirmedBuyingUnits",
          label: "BUs",
          sortable: true,
        },
        {
          key: "ConfirmedYesSheets",
          label: "Yes",
          sortable: true,
        },
        {
          key: "RestaurantID" + "_2",
          label: "%",
          sortable: true,
          formatter: "yesPerc",
        },
        {
          key: "ConfirmedAppointments",
          label: "APPTs",
          sortable: true,
        },
        {
          key: "RestaurantID" + "_3",
          label: "%",
          sortable: true,
          formatter: "apptPerc",
        },
        {
          key: "ConfirmedImmediateAppointments",
          label: "7Days",
          sortable: true,
        },
        {
          key: "RestaurantID" + "_4",
          label: "%",
          sortable: true,
          formatter: "appt7Perc",
        },
        {
          key: "ConfirmedKeptAppointments",
          label: "Kept",
          sortable: true,
        },
        {
          key: "RestaurantID" + "_5",
          label: "%",
          sortable: true,
          formatter: "keptPerc",
        },
        {
          key: "BusinessWritten",
          label: "Bus. Writ.",
          sortable: true,
        },
        {
          key: "RestaurantID" + "_6",
          label: "%",
          sortable: true,
          formatter: "bwPerc",
        },
        {
          key: "ProductionSubmitted",
          label: "$Val",
          sortable: true,
        },
      ],
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
    };
  },
  components: {
    cTable,
  },
  async created() {
    
    if (this.$store.state.seminar.seatings.length === 0)
    {
    await this.$store.dispatch("seminar/fetchSeatings");
    }
    this.filterList();
  },
  computed: {
    totalRows: function () {
      return this.$store.state.seminar.seatings.length;
      //return 4;
    },
    totalObjects: function () {
      return this.$store.state.seminar.seatings;
      //return 4;
    },
    totalRowsFiltered: function () {
      return this.filteredObjects.length;
    },
    isNavVisible: function () {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "globals"]),
  },
  methods: {
    my_download() {
         var _op =
       {
    "FromDate": this.$store.state.globals.default_from_date,
		"ToDate": this.$store.state.globals.default_to_date,
		"UserProfileID": this.$store.state.globals.default_pp,
		"Search": this.$store.state.globals.default_search_string
       }
   
       

this.$store
        .dispatch("seminar/DownloadAPTReport", _op)
        .then(response => (
          window.open("http://rm_api.revolutionterritorymanager.com/Output/" + response.data["APTReportDownloadResult"], "_blank") 
        )
        );
    },
    mmdd(value) {
      if (value) {
        return value.substr(0, value.lastIndexOf("/"));
      }
    },
    attendeePerc(value, key, item) {
      if (item.RSVPCount !== 0) {
        return ((item.ConfirmedAttendees / item.RSVPCount) * 100).toFixed(2);
      }
    },
    yesPerc(value, key, item) {
      if (item.ConfirmedAttendees !== 0) {
        return (
          (item.ConfirmedYesSheets / item.ConfirmedAttendees) *
          100
        ).toFixed(2);
      }
    },
    apptPerc(value, key, item) {
      if (item.ConfirmedYesSheets !== 0) {
        return (
          (item.ConfirmedAppointments / item.ConfirmedYesSheets) *
          100
        ).toFixed(2);
      }
    },
    appt7Perc(value, key, item) {
      if (item.ConfirmedAppointments !== 0) {
        return (
          (item.ConfirmedImmediateAppointments / item.ConfirmedAppointments) *
          100
        ).toFixed(2);
      }
    },
    keptPerc(value, key, item) {
      if (item.ConfirmedAppointments !== 0) {
        return (
          (item.ConfirmedKeptAppointments / item.ConfirmedAppointments) *
          100
        ).toFixed(2);
      }
    },
    bwPerc(value, key, item) {
      if (item.ConfirmedKeptAppointments !== 0) {
        return (
          (item.BusinessWritten / item.ConfirmedKeptAppointments) *
          100
        ).toFixed(2);
      }
    },
    filterList: function () {
      this.filteredObjects = this.$store.state.seminar.seatings.filter(
        (seating) =>
          new Date(seating.DateOfSeating) >=
            new Date(this.$store.state.globals.default_dates.from_date) &&
          new Date(seating.DateOfSeating) <=
            new Date(this.$store.state.globals.default_dates.to_date) &&
          (seating.Parent.Owner.UserProfileID ===
            this.$store.state.globals.default_pp ||
            !this.$store.state.globals.default_pp)
      );
      this.filteredObjects = this.filteredObjects.filter(
        (seating) =>
          seating.Parent.Territory.TerritoryName.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1 ||
          seating.Restaurant.Name.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1
      );
    },
  },
  watch: {
   "totalObjects": function (newValue, oldValue) {
      this.$store.dispatch("seminar/fetchSeatings").then(this.filterList());
    },
    
    "$store.state.globals.default_from_date": function (newValue, oldValue) {
      this.filterList();
    },
    "$store.state.globals.default_to_date": function (newValue, oldValue) {
      this.filterList();
    },
    "$store.state.globals.default_pp": function (newValue, oldValue) {
      this.filterList();
    },
    "$store.state.globals.default_search_string": function (
      newValue,
      oldValue
    ) {
      this.filterList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
